import { render } from "./sStudyDesign.vue?vue&type=template&id=10a48d72&scoped=true"
import script from "./sStudyDesign.vue?vue&type=script&lang=js"
export * from "./sStudyDesign.vue?vue&type=script&lang=js"

import "./sStudyDesign.vue?vue&type=style&index=0&id=10a48d72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a48d72"]])

export default __exports__